export enum HowManyToList {
    Single,
    Multiple,
}
